import { render, staticRenderFns } from "./spinwheel_bets.vue?vue&type=template&id=8c80b002&scoped=true&"
import script from "./spinwheel_bets.vue?vue&type=script&lang=js&"
export * from "./spinwheel_bets.vue?vue&type=script&lang=js&"
import style0 from "./spinwheel_bets.vue?vue&type=style&index=0&id=8c80b002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c80b002",
  null
  
)

export default component.exports